var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteToFolderLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 25.6
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.72 13.84a2.913 2.913 0 002.06-4.98 2.913 2.913 0 10-4.12 4.12 2.81 2.81 0 002.06.86zm-6.4 6.96h12.8v-.76a2.849 2.849 0 00-1.7-2.6 9.967 9.967 0 00-4.7-.92 9.967 9.967 0 00-4.7.92 2.849 2.849 0 00-1.7 2.6zM2.4 25.6a2.273 2.273 0 01-1.68-.74A2.325 2.325 0 010 23.2V2.4A2.325 2.325 0 01.72.74 2.273 2.273 0 012.4 0h10.2a2.391 2.391 0 011.72.72L16 2.4h13.6a2.3 2.3 0 011.66.74A2.3 2.3 0 0132 4.8v18.4a2.539 2.539 0 01-2.4 2.4z"
  })));
}
export default SvgInviteToFolderLogin;